import { Component, OnInit, ViewChild, ElementRef, NgZone, Input, HostListener } from '@angular/core';
import { PetsService } from '../../_services';
import { MapsAPILoader } from '@agm/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Options } from 'ng5-slider';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
	selector: 'app-search',
	templateUrl: './search.component.html',
	styleUrls: ['./search.component.scss']
})

export class SearchComponent implements OnInit {

	public showPets = true;
	pageType: string;
	breedId: '';
	speciesId: '';
	//breedName: '';
	radiusDistance: number = 10;
	@Input() homePageOperationTypeId: number = 0;
	@HostListener('window:popstate', ['$event'])
	onPopState(event) {

		localStorage.setItem('backbutton', "1");
	}

	constructor(
		private pets: PetsService,
		private router: Router,
		private formbuilder: FormBuilder,
		private mapsAPILoader: MapsAPILoader,
		private ngZone: NgZone,
		private route: ActivatedRoute,
		private SpinnerService: NgxSpinnerService
	) { }

	searchForm: FormGroup;
	ListView = false;
	ListMap = true;
	// by default on mobile list view should be displayed
	MobileList = true;
	OperationTypeID: any = "1";
	OperationTypeIDForSearch: any = "0";
	//petImagePath = environment.apiBaseUrl + "/Static/Images/";
	petDetailPath = environment.apiBaseUrl + "/pet-detail?PetID=";
	submitted = false;
	page = 1;
	private geoCoder;
	@ViewChild('search')
	private searchElementRef: ElementRef;
	totalCount: any;
	totalLost: any;
	totalFound: any;
	totalReUnite: any;
	recordFiltered: number;
	recordTotal: number;
	registerSuccess: false;
	calledFrom: string = "";
	queryParams: any;
	options: Options = {
		floor: 0,
		ceil: 100
	};
	public styles: any = [{ "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }] }, { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] }, { "elementType": "labels.text.stroke", "stylers": [{ "color": "#f5f5f5" }] }, { "featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{ "color": "#bdbdbd" }] }, { "featureType": "poi", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }] }, { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }] }, { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }, { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }] }, { "featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] }, { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#dadada" }] }, { "featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] }, { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }, { "featureType": "transit", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit.line", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }] }, { "featureType": "transit.station", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#c9c9c9" }] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }]

	petDetailsList: any[];
	loader: boolean;
	// google maps zoom level
	zoom: any = 13;

	// initial center position for the map
	lat: any;
	lng: any;
	radiousMils: any;
	minClusterSize = 50;
	tabActive: number = 3;
	Pets: any = {};
	isDesktopView = true;
	floatingDiv: any;
	topPosition: any;
	absPosition: any;
	searchfilterdivPosition: any;
	filterDiv: any;
	@ViewChild('ListMap') floatingMap!: ElementRef;
	@ViewChild('searchfilterdiv') searchfilterdiv!: ElementRef;
	@ViewChild('ProductList') ProductList!: ElementRef;
	public petCityDetails: any;
	public checkValue = false;

	ngOnInit() {
		
		//this.SpinnerService.show();  
		const regex_mobile = new RegExp(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/, 'i');
		this.isDesktopView = !regex_mobile.test(window.navigator.userAgent);
if(!this.isDesktopView){
	this.ListMap = false;
}
		if (this.router.url == '/search')
			this.scrollSeacrh();

		this.pageType = this.route.snapshot.paramMap.get("type");
		this.route.queryParams.subscribe(params => {
			if (params['registerSuccess']) {
				this.registerSuccess = params['registerSuccess'];
				this.lat = params["lat"];
				this.lng = params["lng"];
				this.speciesId = params['SpeciesID'] || '';
				this.pageType = parseInt(params['OperationTypeID']) == 1 ? 'found' : 'lost';
				if(this.registerSuccess){
					this.ListMap = false;
				}
			}
		});
		this.searchForm = this.formbuilder.group({
			SpeciesID: [this.speciesId],
			BreedID: [this.breedId],
			Area: [''],
			lat: [''],
			lng: [''],
			radiousDistance: [this.radiusDistance],
			OperationTypeID: ['1'],
			MasterSpecies: [''],
			SpeciesTypeValue: ['']
		});

		this.pets.specValue.subscribe(val => {
			if (val) {
				this.searchForm.controls['SpeciesTypeValue'].patchValue(val);
				this.changeSpeciesType();
			}
		})
		//load Places Autocomplete
		this.mapsAPILoader.load().then(() => {
			this.setCurrentLocation();
			this.geoCoder = new google.maps.Geocoder;
			let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
				types: [], 
				componentRestrictions : {country : "no"}
			});
			autocomplete.addListener("place_changed", () => {
				this.ngZone.run(() => {
					//get the place result
					let place: google.maps.places.PlaceResult = autocomplete.getPlace();
					//verify result
					if (place.geometry === undefined || place.geometry === null) {
						return;
					}
					this.searchForm.controls['Area'].patchValue(place.formatted_address)
					this.searchForm.controls['lat'].patchValue(place.geometry.location.lat());
					this.searchForm.controls['lng'].patchValue(place.geometry.location.lng());
					//set latitude, longitude and zoom
					this.lat = place.geometry.location.lat();
					this.lng = place.geometry.location.lng();
					this.zoom = 13;
					this.onSubmit();
				});
			});
		});
		let ListView = 'ListMap';
		ListView = localStorage.getItem('ListView');
		if (ListView) {
			this.ListView = (ListView == 'ListView') ? true : false;
			this.ListMap = (ListView == 'ListMap') ? true : false;
		}
		let SearchFilters = localStorage.getItem('SearchFilters');
		if (SearchFilters) {
			this.queryParams = JSON.parse(SearchFilters);
		}
		this.searchForm.controls['radiousDistance'].patchValue(this.radiusDistance);
		// if (this.queryParams && this.queryParams.radiousDistance) {
		// 	this.searchForm.controls['radiousDistance'].patchValue(this.queryParams.radiousDistance)
		// }
		if (this.pageType) {
			const pageTypeVar = this.pageType == 'lost' ? 1 : 2;
			this.searchForm.controls['OperationTypeID'].patchValue(pageTypeVar)
			this.OperationTypeID = pageTypeVar;
		} else {
			this.searchForm.controls['OperationTypeID'].patchValue("1")
			if (this.queryParams && this.queryParams.OperationTypeID) {
				this.searchForm.controls['OperationTypeID'].patchValue(this.queryParams.OperationTypeID)
				this.OperationTypeID = this.queryParams.OperationTypeID;
			}
			///this is done for the home page if user go to home page by default missing should be selected
			if (this.homePageOperationTypeId == 1) {
				this.searchForm.controls['OperationTypeID'].patchValue(this.homePageOperationTypeId);
				this.OperationTypeID = this.homePageOperationTypeId;
			}
		}
		this.searchForm.controls['Area'].patchValue("")
		if (this.queryParams && this.queryParams.Area) {
			this.searchForm.controls['Area'].patchValue(this.queryParams.Area)
		}
		if (this.queryParams && this.queryParams.radiousDistance) {
			this.radiousMils = this.queryParams.radiousDistance;
		}
		window.addEventListener('scroll', this.scrollEvent, true);		
	}

	  ontouchmove(event: DragEvent) {
		const touch = (<any>event).changedTouches[0].clientY;
		this.floatingMap.nativeElement.setAttribute('style', 'height:calc(100vh - '+touch+'px)!important');
		console.log('dragging', event);
	  }
	
	scrollEvent = (event: any): void => {
		if (window.matchMedia('(min-width: 768px)').matches && this.recordFiltered > 0) {
			if (this.floatingDiv != null) {
			if ((event.target.scrollTop > this.topPosition) && (event.target.scrollTop < this.absPosition)) {
				$('.map-view').addClass('mapsticky');
				$('.map-view').removeClass('mapabsolute');

			} else if ((event.target.scrollTop > this.topPosition) && (event.target.scrollTop > this.absPosition)) {
				$('.map-view').removeClass('mapsticky');
				$('.map-view').addClass('mapabsolute');

			} else {
				$('.map-view').removeClass('mapsticky');
				$('.map-view').removeClass('mapabsolute');
			}
		}
			if (this.filterDiv != null) {
				if ((event.target.scrollTop > this.searchfilterdivPosition) && (event.target.scrollTop < this.absPosition)) {
					this.filterDiv.addClass('filtersticky');
					this.filterDiv.removeClass('filterabsolute');

				} else if ((event.target.scrollTop > this.searchfilterdivPosition) && (event.target.scrollTop > this.absPosition)) {
					this.filterDiv.removeClass('filtersticky');
					this.filterDiv.addClass('filterabsolute');

				} else {
					this.filterDiv.removeClass('filtersticky');
					this.filterDiv.removeClass('filterabsolute');
				}
			}
		}else{
			if (this.floatingDiv != null) {
				$('.map-view').removeClass('mapsticky');
				$('.map-view').removeClass('mapabsolute');
				
			}
			if (this.filterDiv != null) {
				this.filterDiv.removeClass('filtersticky');
				this.filterDiv.removeClass('filterabsolute');
				
			}
		}
	}	
	formatLabel(value: number) {
		this.radiousMils = value;
		return value;
	}

	infoWindowOpened = null
	previous_info_window = null

	markers: marker[] = [
		{
			lat: 51.673858,
			lng: 7.815982,
			draggable: true
		}
	]

	close_window() {
		if (this.previous_info_window != null) {
			if (this.previous_info_window) this.previous_info_window.close()
		}
	}
	changeListMapView(type: string) {
		$("#dragbar").hide();
		this.ListMap = true
		if (type == "List") {
			this.ListMap = false
			this.MobileList = true;
			$('#bottomContent').show();
		    $('#footer').show();
		}
		if (type == 'ListMap') {
			this.MobileList = false;
			if (window.matchMedia('(max-width: 600px)').matches) {
				setTimeout(() => {	
					$("#dragbar").show();			
					$('.floatingList').addClass('FixedProductList');
			        $('.floatingProductList').addClass('productListNew');
					$('#listmap-section').addClass('listmap-sectionHeight');
					$('.floatingList').addClass('listheight');
					$('#primary-content-wrap').addClass('mapheight');
					$('.map-view').addClass('map-viewBorder');
					$('#primary-content-wrap').insertBefore('.FixedProductList');
					$('#bottomContent').hide();
					$('#footer').hide();
					
				}, 500);
			}			
		}
	}
	clickedMarker(label: string, index: number, infoWindow) {
		if (this.previous_info_window == null)
			this.previous_info_window = infoWindow;
		else {
			this.infoWindowOpened = infoWindow
			if (this.previous_info_window) this.previous_info_window.close()
		}
		this.previous_info_window = infoWindow
		// console.log(`clicked the marker: ${label || index}`)
	}

	onSubmit() {
		$("#dragbar").hide();
		this.submitted = true;
		this.page = 1;
		this.zoom = (Math.round(14 - Math.log(this.searchForm.value.radiousDistance) / Math.LN2)) + 1;
		if (this.pageType) { // if search page
			this.OperationTypeID = this.pageType == 'lost' ? 1 : 2;
		} else {
			this.OperationTypeID = this.searchForm.value.OperationTypeID;
		}
		// console.log("Your OperationTypeId ius :" + this.OperationTypeID );
		if (this.searchForm.invalid) {
			return;
		}
		let ListPageNo = localStorage.getItem('ListPageNo');
		if (ListPageNo) {
			this.page = Number(ListPageNo);
		}
		this.getFilterPetsGrid(this.page);
	}

	toggleCluster() {
		this.minClusterSize = (this.minClusterSize < 5) ? 50 : 2;
	}

	private setCurrentLocation() {
		if ("geolocation" in navigator) {
			navigator.geolocation.getCurrentPosition((position) => {
				if (position) {
					this.lat = position.coords.latitude;
					this.lng = position.coords.longitude;
					// this.zoom = 13;
					this.zoom = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? 11 : 13;
					//(this.MapView) ? this.showMapView() : this.showGridView();
					this.searchForm.controls['lat'].patchValue(this.lat);
					this.searchForm.controls['lng'].patchValue(this.lng);
					this.onSubmit();
					setTimeout(() => {
						this.getAddress(this.lat, this.lng);
					}, 3000);
				}
			},
				(error) => {
					let searchParameters = JSON.parse(localStorage.getItem('SearchFilters'));
					let area;
					this.lat = searchParameters && typeof (searchParameters.lat) != 'undefined' && searchParameters.lat != '' ? searchParameters['lat'] : 59.9138688;
					this.lng = searchParameters && typeof (searchParameters.lng) != 'undefined' && searchParameters.lng != '' ? searchParameters['lng'] : 10.7522454;
					area = searchParameters && typeof (searchParameters.Area) != 'undefined' && searchParameters.Area != '' && typeof searchParameters.Area == 'string' ? searchParameters['Area'] : "Oslo, Norge";
					this.zoom = 13;
					this.searchForm.controls['Area'].patchValue(area);
					this.onSubmit();
				});

		}
	}
	getFilterPetsGrid(page: number, isPagination?: boolean) {
		this.loader = true;
		this.page = page;
		let filters: any = {};
		let startIndex = (this.page == 1) ? 0 : (page - 1) * 50;
		let endIndex = startIndex + 50;
		localStorage.setItem('SearchFilters', JSON.stringify(this.searchForm.value));

		let OperationTypeId = this.searchForm.value.OperationTypeID;
		let searchOT = 0;
		if (OperationTypeId == 1) {
			searchOT = 1;
		}
		// console.log(this.searchForm.value.SpeciesID);
		filters = {
			"startIndex": startIndex,
			"endIndex": endIndex,
			"latitude": this.lat,
			"longitude": this.lng,
			"radiusMils": this.searchForm.value.radiousDistance,
			"operationTypeId": this.searchForm.value.OperationTypeID,
			"SpeciesID": this.searchForm.value.SpeciesID,
			"BreedID": this.searchForm.value.BreedID,
			"searchNeighbourPets": searchOT,
			"MasterSpecies": this.searchForm.value.MasterSpecies
		}
		if (this.pageType) { // if search page
			filters.searchNeighbourPets = this.pageType == 'lost' ? 1 : 0;
		}
		this.pets.GetLostFoundPetsList(filters).subscribe(response => {	
					
			this.petDetailsList = response.data;
			this.loader = false;

			// this is done for the  thankyou page.. if user successfulll register then filter the data as per brreed
			if (response.data && response.data.length > 0 && this.registerSuccess) {
				this.petDetailsList = response.data.filter(item => item.MasterSpeciesID == parseInt(this.speciesId));
				this.zoom = 15;
			}
			else {
				this.pets.assignListData(this.petDetailsList);
			}

			this.totalLost = response.TotalLost;
			this.totalFound = response.TotalFound;
			this.totalReUnite = response.TotalReUnite;
			this.totalCount = response.RecordsTotal;
			this.recordFiltered = 1;

			if (response.RecordsFiltered == 0) {
				this.recordFiltered = 0;
				this.lat = 59.9138688;
				this.lng = 10.7522454;
			}
			
			this.markers = this.petDetailsList;
			this.markers.forEach((el: any) => {
				if (el.MasterSpecies == 'Hund') {
					el.customMarker = this.OperationTypeID == 2 ? 'assets/img/h-icon.png' : 'assets/img/k-icn-h.png'
				}
				else if (el.MasterSpecies == 'Katt') {
					el.customMarker = this.OperationTypeID == 2 ? 'assets/img/k-icn.png' : 'assets/img/k-icn-k.png'
				}
				else {
					el.customMarker = this.OperationTypeID == 2 ? 'assets/img/a-icon.png' : 'assets/img/a-icon-k.png'
				}
			});
		
			localStorage.setItem('ListPageNo', this.page.toString());
			this.OperationTypeIDForSearch = response.operationTypeId;
			if (window.matchMedia('(min-width: 768px)').matches && this.recordFiltered > 0) {
				setTimeout(() => {
					this.topPosition = this.floatingMap.nativeElement.getBoundingClientRect().top;
					this.searchfilterdivPosition = this.searchfilterdiv.nativeElement.getBoundingClientRect().top;
					this.absPosition = $('.height').outerHeight();
					this.floatingDiv = $('.map-view');
					this.filterDiv = $('.searchfilterdiv');					
					//this.SpinnerService.hide();  
				}, 500);
			}
			// else
			// {
			// 	this.SpinnerService.hide();  	
			// }								
		},
			error => {
				//this.SpinnerService.hide();  
			});

	}

	changeSpeciesType() {
		let selectedSpeciesValue = this.searchForm.value.SpeciesTypeValue;
		this.searchForm.value.SpeciesID = selectedSpeciesValue;
		this.onSubmit();
	}

	getAddress(latitude, longitude) {
		const localArea = JSON.parse(localStorage.getItem('_locArea'));
		//if same lat lng dont need to call geocoder api again
		if (localArea && localArea.lat == latitude && localArea.lng == longitude) {
			this.searchForm.controls['Area'].patchValue(localArea.area);
			this.searchForm.controls['lat'].patchValue(latitude);
			this.searchForm.controls['lng'].patchValue(longitude);
			this.onSubmit();
			return;
		}
		this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
			if (status === 'OK') {
				if (results[0]) {
					// console.log(results[0].formatted_address);
					this.searchForm.controls['Area'].patchValue(results[0].formatted_address);
					const locObject = { lat: latitude, lng: longitude, area: results[0].formatted_address };
					localStorage.setItem('_locArea', JSON.stringify(locObject));
				} else {
					window.alert('No results found');
				}
			} else {
				window.alert('Geocoder failed due to: ' + status);
			}
		});
	}

	openModal(event) {
		document.getElementById(event.currentTarget.parentElement.nextElementSibling.id).style.display = "block";
	}

	closeModal(event) {
		document.getElementById(event.currentTarget.parentElement.id).style.display = "none";
	}

	resetSearchFilters() {
		this.OperationTypeID = "0";
		this.searchForm.controls.Area.reset();
		this.searchForm.controls['OperationTypeID'].patchValue("0")
		if (this.queryParams.callingFrom == "home") {
			this.searchForm.controls.SpeciesID.patchValue(this.queryParams.speciesId);
		} else {
			this.searchForm.controls.SpeciesID.patchValue('');
		}
		this.searchForm.controls.BreedID.patchValue('');
		// this.searchForm.controls.lat = this.lat;
		// this.searchForm.controls.lng = this.lng;
		localStorage.setItem("SearchFilters", "");
		this.setCurrentLocation();
		if (this.queryParams.value) this.queryParams.value = "";
		this.onSubmit();
		this.router.navigate(['list-pets'], { queryParams: { OperationTypeID: this.OperationTypeID, radiousDistance: this.radiusDistance } });
		//this.router.navigate([this.router.url]);
	}

	SearchPetByType(SearchPetID: any) {
		if (SearchPetID == 1) {
			this.tabActive = 1;
			this.searchForm.controls['SpeciesID'].patchValue(1);
		} else if (SearchPetID == 2) {
			this.tabActive = 2;
			this.searchForm.controls['SpeciesID'].patchValue(2);
		} else if (SearchPetID == 3) {
			this.tabActive = 3;
			this.searchForm.controls['SpeciesID'].patchValue('');
			this.searchForm.controls['BreedID'].patchValue('');
			this.onSubmit()
		}
	}

	ngOnDestroy(): void {
		//Called once, before the instance is destroyed.
		//Add 'implements OnDestroy' to the class.
		localStorage.setItem('SearchFilters', JSON.stringify(this.searchForm.value));
	}

	changeOperationType(id, event: any) {
		localStorage.setItem('ListPageNo', "");
		this.totalCount = '';
		this.searchForm.controls['OperationTypeID'].patchValue(id)
		var els = document.querySelectorAll('.active-stat');
		for (var i = 0; i < els.length; i++) {
			els[i].classList.remove('active-stat')
		}
		event.srcElement.classList.add("active-stat");
		if (id == 1) {
			this.searchForm.value.OperationTypeID = 1;
			this.checkValue = true;
		}
		this.searchForm.controls['SpeciesTypeValue'].patchValue('');
		this.searchForm.value.SpeciesTypeValue = "";
		this.searchForm.value.SpeciesID = "";
		this.onSubmit();
	}

	//go to pet details page
	// goToPetDetails = (petDetail: any) => {
	// 	debugger;
	// 	let atobStr: string = "";
	// 	const petName = this.calledFrom == "home" || localStorage.getItem('_calledFrom') == 'home' ? `${petDetail.Color ? petDetail.Color : ''} ${petDetail.BreedsName ? petDetail.BreedsName : ''} ${petDetail.SpeciesName ? petDetail.SpeciesName : ''} ${'i ditt nærområde'}` : `${petDetail.Color ? petDetail.Color : ''} ${petDetail.MasterBreed ? petDetail.MasterBreed : ''} ${petDetail.MasterSpecies ? petDetail.MasterSpecies : ''} ${(this.OperationTypeID == "1") ? 'Tapt' : 'Funnet'} I ${petDetail.City ? petDetail.City : ''}`;
	// 	const petNameWithoutChar = petName.replace(/[^a-zA-Z ]/g, "");
	// 	const urlString = petNameWithoutChar.trim().toLowerCase().split(' ').join('-');
	// 	const removeChar = urlString.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
	// 	const encodedString = encodeURI(removeChar);
	// 	if ((this.calledFrom == "home" || localStorage.getItem('_calledFrom') == 'home') && this.calledFrom !== "menu") {
	// 		atobStr = btoa(petDetail.ChipId);
	// 		localStorage.setItem('_calledFrom', 'home');
	// 	}
	// 	else {
	// 		atobStr = btoa(petDetail.LostFoundID);
	// 		localStorage.setItem('_calledFrom', '');
	// 	}
	// 	localStorage.setItem('_page', 'list_page');
	// 	this.router.navigate([`list-pets/pet-detail/${atobStr}/${encodedString}`], { queryParams: { opType: this.OperationTypeID } });
	// } 1= lost , 2= found , registered
	//	go to pet details page

	goToPetDetails = (petDetail: any) => {
		let encryptedPet_ChipId: string = "";
		var LostFoundPetID = petDetail.LostFoundID;

		var OperationTypeID = petDetail.OperationTypeID;
		localStorage.removeItem('LostFoundPetID');
		localStorage.removeItem('OperationTypeID');

		localStorage.setItem("LostFoundPetID", LostFoundPetID);
		localStorage.setItem("OperationTypeID", OperationTypeID);

		let queryParams;
		let type;
		var top = window.pageYOffset || document.documentElement.scrollTop
		if (petDetail.IsNeighbourPet) {
			type = 'registered'
			queryParams = { "ChipID": petDetail.ChipID, "OperationTypeId": petDetail.OperationTypeID }
			var ChipID = petDetail.ChipID;
			localStorage.setItem("pet_ChipID", ChipID);
			encryptedPet_ChipId = btoa(JSON.stringify(queryParams));
			localStorage.setItem("Url_ChipId", petDetail.ChipID);
			localStorage.removeItem('Url_PetId');
		} else {
			type = petDetail.OperationTypeID == 1 ? 'lost' : 'found'
			queryParams = { "PetID": petDetail.LostFoundID, "OperationTypeId": petDetail.OperationTypeID }
			encryptedPet_ChipId = btoa(JSON.stringify(queryParams));
			localStorage.setItem("Url_PetId", petDetail.LostFoundID);
			localStorage.removeItem('Url_ChipId');
		}
		localStorage.setItem('_page', 'list_page');
		let PostTitle = petDetail.PostTitle.replace(/[&\/\\#,^/!/%+()$~%.'":*?<>{}]/g, "");
		PostTitle = PostTitle.replace(/\s/g, "_");
		this.router.navigate([`savnetfunnet/${type}/${encryptedPet_ChipId}/${PostTitle}`], { state: { data: this.petDetailsList } });
	}

	errorHandler = (e) => {
		e.target.src = environment.baseUrl + environment.placeholderImg;
	}

	routeToPage = () => {
		const path = this.pageType == 'lost' ? 'report-found' : 'report-lost';
		localStorage.setItem('navigatefrom', 'search');
		this.router.navigate([path]);
	}
	scrollSeacrh = () => {
		const element = document.querySelector('#SeacrhDiv');
		element.scrollIntoView({ behavior: 'smooth' });
	}
	handleClear() {
		this.searchForm.controls['Area'].patchValue('');
	}
}

interface marker {
	lat: number;
	lng: number;
	label?: string;
	draggable?: boolean;
	LostFoundID?: number;
	UserLoginID?: number;
	OperationTypeID?: number;
	PetName?: string;
	DateOfBirth?: string;
	ImagePath?: string;
	City?: string;
	MasterSpecies?: string;
	MasterBreed?: string;
	Color?: string;
	PetPhoto?: string;
	PostTitle?: string;
}


interface Ipetdetalils {
	LostFoundID: number;
	UserLoginID: number;
	IsChipped: string;
	ChipID: string;
	OperationTypeID: number;
	PetName: string;
	PetType: string;
	SpeciesID?: number;
	MasterSpecies: string;
	BreedID?: number;
	MasterBreed: string;
	Gender: string;
	Casted: string;
	DateOfBirth?: string;
	DisplayDateOfBirth: string;
	LostFoundDate?: string;
	DisplayLostFoundDate: string;
	Area: string;
	Commune: string;
	City: string;
	State: string;
	StateID?: number;
	Country: string;
	CountryID?: number;
	AdditionalInfo: string;
	ImageID?: number;
	ImagePath: string;
	ThumbnailImagePath: string;
	Color: string;
	CoatLength: string;
	Description: string;
	lat: string;
	lng: string;
	DistancePoint: string;
	OwnerContactEmail: string;
	IsReunite: boolean;
	CreatedDate: string;
	CreatedBy: string;
	UpdatedDate: string;
	UpdatedBy: string;
	Status: boolean;
}
